// src/lib/sam-api/verify.ts
import { samApi } from './client';
import { supabase } from '../supabase';

export async function verifyDataPipeline() {
  console.log('Starting data pipeline verification...');

  try {
    // 1. Test SAM.gov API Connection
    console.log('Testing SAM.gov API connection...');
    const searchResult = await samApi.searchContracts({
      size: 1
    });
    // Updated field name from "contracts" to "items"
    console.log(`SAM.gov API Test: ${searchResult.items.length > 0 ? 'SUCCESS' : 'FAILED'}`);

    // 2. Verify Supabase Connection
    console.log('Testing Supabase connection...');
    const { data: testData, error: testError } = await supabase
      .from('sam_contracts')
      .select('notice_id')
      .limit(1);
    
    if (testError) throw testError;
    console.log('Supabase Connection Test: SUCCESS');

    // 3. Check Required Fields
    const { data: contracts, error: contractsError } = await supabase
      .from('sam_contracts')
      .select(`
        notice_id,
        title,
        agency,
        naics_code,
        description,
        status,
        funding_amount,
        due_date,
        solicitation_url,
        naics_codes,
        psc_code,
        award_number,
        award_date,
        award_amount,
        point_of_contact
      `)
      .limit(5);

    if (contractsError) throw contractsError;

    console.log('\nSample Contract Data:');
    contracts?.forEach((contract, index) => {
      console.log(`\nContract ${index + 1}:`);
      console.log('- Notice ID:', contract.notice_id);
      console.log('- Title:', contract.title);
      console.log('- Agency:', contract.agency);
      console.log('- NAICS:', contract.naics_code);
      console.log('- Status:', contract.status);
      console.log('- Due Date:', contract.due_date);
      
      // Log new fields if available
      if (contract.solicitation_url) console.log('- Solicitation URL:', contract.solicitation_url);
      if (contract.award_amount) console.log('- Award Amount:', contract.award_amount);
      if (contract.point_of_contact) console.log('- Point of Contact:', contract.point_of_contact);
    });

    // 4. Verify Data Integrity
    const dataIntegrityIssues = contracts?.reduce((issues, contract) => {
      if (!contract.notice_id) issues.push('Missing notice_id');
      if (!contract.title) issues.push('Missing title');
      if (!contract.agency) issues.push('Missing agency');
      if (!contract.naics_code) issues.push('Missing NAICS code');
      if (!contract.status) issues.push('Missing status');
      return issues;
    }, [] as string[]);

    if (dataIntegrityIssues?.length) {
      console.warn('Data Integrity Issues Found:', dataIntegrityIssues);
    }

    return {
      success: true,
      contractCount: contracts?.length || 0,
      sampleData: contracts?.[0],
      dataIntegrityIssues
    };

  } catch (error) {
    console.error('Data Pipeline Verification Failed:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
      details: error
    };
  }
}
